import type { SxProps, Theme } from '@mui/material'
// eslint-disable-next-line settle/preferred-modules
import { mergeSx as mergeSxBase } from 'merge-sx'

export const mergeSx = (...styles: (SxProps<Theme> | false | undefined)[]): SxProps<Theme> =>
  mergeSxBase<Theme>(...styles)
